export const POCKETBASE_REACHABLE_EVENT = 'thryveloop:pocketbase-reachable';

export function isPocketBaseReachableHttpStatus(status) {
  const code = Number(status || 0);
  return code >= 200 && code < 500;
}

export function notifyPocketBaseReachable(detail = {}) {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') {
    return false;
  }
  window.dispatchEvent(new CustomEvent(POCKETBASE_REACHABLE_EVENT, {
    detail: {
      source: 'unknown',
      at: Date.now(),
      ...detail
    }
  }));
  return true;
}

export function recordPocketBaseResponseReachability(response, detail = {}) {
  if (!isPocketBaseReachableHttpStatus(response?.status)) {
    return false;
  }
  return notifyPocketBaseReachable({
    ...detail,
    status: Number(response.status),
    url: response.url || detail.url || ''
  });
}
